import React from 'react';
import Form from "react-bootstrap/Form";

function InputEntrar({type, placeholder, name, value, onChange, maxLength}) {
    return (
        <Form.Control
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            required
        />
    );
}

export default InputEntrar;